import axiosInstance from "./axiosInstance";


export const detectOperatorByNumber= async (payload) => {
  console.log("get the perate",payload)
  try {
    const response = await axiosInstance.post(`/api/recharge/detect-operator`,payload);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};

export const rechargeOperatorByNumber= async () => {

  try {
    const response = await axiosInstance.get(`/api/recharge/recharge-operator`);
    return {
   success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};

export const getRecharges_Plans= async (payload) => {
    const response = await axiosInstance.post(`/api/recharge/api/get-plans`,payload);
    return response?.data
  
};

// export const doRechargeOperatorByNumber= async (data) => {
//   try {
//     const response = await axiosInstance.post(`/api/recharge/api/mobile-recharge`,data);
//     return {
//       success: true,
//       data: response?.data?.data,
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         " failed. Please try again.",
//       status: error.response?.status || 500,
//     };
//   }
// };



export const doRechargeOperatorByNumber = async (data) => {
  const res = await axiosInstance.post(
    "/api/recharge/api/mobile-recharge",
    data
  );

  // backend decides success/fail
  return res.data;
};



export const fetchSingleBeneficiaryAccount= async (bankId) => {
  try {
    const response = await axiosInstance.get(`/api/dmt/single-bank/${bankId}`);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
// export const dth_fetch_info = async (data) => {
//   try {
//     const response = await axiosInstance.post(`/api/recharge/dth/find_data`,data);
//     return {
//       success: true,
//       data: response?.data?.data,
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         " failed. Please try again.",
//       status: error.response?.status || 500,
//     };
//   }
// };




export const dth_fetch_info = async (data) => {
  try {
    const response = await axiosInstance.post(
      `/api/recharge/dth/find_data`,
      data
    );

    // backend success false bhi ho sakta hai
    if (!response?.data?.success) {
      return {
        success: false,
        message: response?.data?.message || "Failed to fetch DTH info",
      };
    }

    return {
   success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "Successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Something went wrong",
      status: error.response?.status || 500,
    };
  }
};

export const fetchRechagesHistory = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`/api/recharge/dth/rechage_history`,{
      params:params
    });
    return {
    success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};

export const fetchRechargeById = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/recharge/transaction/${id}`);
    return {
      success: response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to fetch transaction",
      status: error.response?.status || 500,
    };
  }
};



export const fetchBillHistory = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`/api/recharge/dth/rechage_history/bbps`,{
      params:params
    });
    return {
 success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
